import type {IconProps} from 'bonprix-design-system';

// Keyed by shop id (shopLink.id / subshop filterOption.value), which survives category renames and SEO slug changes.
const CATEGORY_ICONS: Record<string, IconProps['variant']> = {
    '19412': 'review',
    '5906': 'clothing-dress',
    '5506': 'clothing-shirt',
    '5497': 'clothing-trousers',
    '5899': 'clothing-blouse',
    '5489': 'clothing-jeans',
    '5903': 'clothing-skirt',
    '5494': 'clothing-sweater',
    '703883': 'clothing-shorts',
    '524': 'clothing-maternity-wear',
    '17026': 'clothing-jumpsuit',
    '5501': 'clothing-jacket',
    '79208': 'clothing-sport',
    '440687': 'clothing-sweatshirt',
    '5504': 'clothing-blazer',
    '260865': 'clothing-party-wear',
    '14453': 'clothing-basic',
    '863902': 'clothing-set',
    '712301': 'diamond',
    '355051': 'clothing-homewear',
    '601602': 'clothing-size',
    '742548': 'recycling',
    '693776': 'discount',
    '20833': 'clothing-traditional-wear',
    '643566': 'clothing-knitwear',
};

export function categoryIcon(shopId: string): IconProps['variant'] | undefined {
    return CATEGORY_ICONS[shopId];
}
